import React from "react";
import { Select } from "antd";

class SelectSearchInput extends React.Component {
  state = {
    data: this.props.data,
    value: undefined,
  };

  handleSearch = (value) => {
    if (value) {
      const newData = this.props.data.filter((obj) => {
        if (this.props.value) {
          return obj[this.props.value].toLowerCase().indexOf(value) > -1;
        } else {
          return obj.toLowerCase().indexOf(value) > -1;
        }
      });
      this.setState({ data: newData });
    } else {
      this.setState({ data: [] });
    }
  };

  handleChange = (value) => {
    this.props.callBackSetValue(value);
  };

  render() {
    
    const options = this.state.data.map((d, ind) => (
      <Select.Option
        key={"option_" + ind}
        value={this.props.keyValue ? d[this.props.keyValue] : d}
        style={{
          fontSize: window.location.pathname === "/linedashtab" ? "17px" : "",
        }}
      >
        {this.props.value ? d[this.props.value] : d}
      </Select.Option>
    ));
    return (
      <Select
        className="selectBox"
        showSearch={window.location.pathname === "/linedashtab" ? false : true}
        value={this.state.value}
        placeholder={this.props.placeholder}
        style={{ ...this.props.style, width: "100%" }}
        defaultActiveFirstOption={false}
        showArrow={false}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        notFoundContent={null}
      >
        {options}
      </Select>
    );
  }
}
export default SelectSearchInput;
